module.exports = __webpack_public_path__ + "static/banner-c17a15091226c29561725c38bc82361a.png";